import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";


export const notificationPrefernceApi = createApi({
    reducerPath: "notification",
    baseQuery: createCustomFetchBaseQuery(),
    endpoints: (builder) => ({
        getNotificationPreference: builder.query({
            query: () => ({
                url: `/notification-preferences/`,
                method: "GET",
            }),
            transformResponse: (response) => ({
                _id: response?.data?._id,
                data: response?.data?.adminNotifications?.email,
                userNotifications: response?.data?.userNotifications,
                organizerNotifications: response?.data?.organizerNotifications,

            })
        }),
        createNotificationPreference: builder.mutation({
            query: (notification) => ({
                url: `/notification-preferences/`,
                method: "POST",
                body: notification,
            }),
        }),
        updateNotificationPreference: builder.mutation({
            query: (notificationPrefernces) => ({
                url: `/notification-preferences`,
                method: "PUT",
                body: notificationPrefernces,
            }),
        }),
        markAsRead: builder.mutation({
            query: (id) => ({
                url: `/notifications/${id}/read`,
                method: "POST",
            }),
        }),
        deleteNotification: builder.mutation({
            query: (id) => ({
                url: `/notifications/${id}`,
                method: "DELETE",
            }),
        }),
        getAllNotifications: builder.query({
            query: () => ({
                url: `/notifications/`,
                method: "GET",
            }),
            transformResponse: (response) => ({
                data: response?.data,
                meta: response?.meta,
            }),
        }),
    }),
});

export const {
    useGetNotificationPreferenceQuery,
    useCreateNotificationPreferenceMutation,
    useUpdateNotificationPreferenceMutation,
    useMarkAsReadMutation,
    useDeleteNotificationMutation,
    useGetAllNotificationsQuery,
} = notificationPrefernceApi;